import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

interface ISelectOption<T> {
  value: T;
  name: string;
  disabled?: boolean;
  disabledText?: string;
}

@Component({
  selector: 'app-multi-select',
  templateUrl: './generic-multi-select.component.html',
  styleUrls: ['./generic-multi-select.component.scss']
})
export class MultiSelectComponent<T> implements OnChanges {
  @Input() public options: ISelectOption<T>[] = [];

  @Input() public label = '';

  @Input() public placeholder = 'Placeholder';

  @Input() public disabled = false;

  @Input() public streamChanges: boolean | 'true' = false;

  @Input() public selectedValue?: ISelectOption<T> | ISelectOption<T>[] | null;

  @Input() public capitalize: boolean = true;

  @Input() public multiple: boolean = false;

  @Output() public change: EventEmitter<T | T[]> = new EventEmitter<T | T[]>();

  public selected: ISelectOption<T> | ISelectOption<T>[] | null = null;

  public open: boolean = false;

  // innerValue: T | null = null;
  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // /* CVA */ propagateChange: (...args: any[]) => any = () => undefined;
  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // /* CVA */ propagateTouched: (...args: any[]) => any = () => undefined;

  ngOnInit(): void {
    // this.selected = this.multiple ? [] : this.options.find((opt) => opt.value === this.selectedValue) || null;
    if (this.multiple) {
      this.selected = this.selectedValue || [];
    } else {
      this.selected = this.selectedValue || null;
    }
  }

  ngOnChanges(_changes: SimpleChanges): void {
    // if (changes.selectedValue) {
    //   if (this.multiple) {
    //     this.selected = changes.selectedValue.currentValue || [];
    //   } else {
    //     this.selected = changes.selectedValue.currentValue || null;
    //   }
    // }
  }

  get selectedName(): string {
    if (this.selected === null) {
      return this.placeholder;
    }

    if (this.multiple) {
      const selected = this.selected as ISelectOption<T>[];

      if (selected.length === 0) {
        return this.placeholder;
      }

      return `${selected.slice(0, 1).map((opt) => opt.name)} ${selected.length - 1 > 0 ? `, +${selected.length - 1}` : ''}`;
    }

    return (this.selected as ISelectOption<T>).name;
  }

  public isSelected(option: ISelectOption<T>): boolean {
    if (this.multiple) {
      return ((this.selected || []) as ISelectOption<T>[]).includes(option);
    }

    return option === this.selected;
  }

  public optionClicked(option: ISelectOption<T>): void {
    // We do nothing if the clicked option is the current one;
    if (!this.multiple && option === this.selected) {
      return;
    }

    if (this.multiple) {
      const selected = this.selected as ISelectOption<T>[];

      console.log('SELECTED', selected);

      if (selected.includes(option)) {
        this.selected = selected.filter((opt) => opt !== option);
      } else {
        this.selected = [...selected, option];
      }

      this.change.emit(this.selected.map((opt) => opt.value));
      // this.propagateChange(this.selected);
    } else {
      this.selected = option;

      this.change.emit(this.selected.value);
      // this.propagateChange(this.selected.value);
      this.open = !this.open;
    }
  }

  // private findProperName(): void {
  //   if (this.innerValue === null) {
  //     this.selected = null;
  //     return;
  //   }

  //   const index = this.options.findIndex((e) => e.value === this.innerValue);

  //   if (index === -1) {
  //     this.selected = null;
  //     return;
  //   }

  //   this.selected = this.options[index];
  // }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.options?.currentValue) {
  //     this.findProperName();
  //   }
  // } // We MUST NOT propagate change here, we are in the init method.

  // /* CVA */ writeValue(value: T): void {
  //   this.innerValue = value;
  //   this.findProperName();
  // }

  // /* CVA */ registerOnChange(fn: any): void {
  //   this.propagateChange = fn;
  // } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  // /* CVA */ registerOnTouched(fn: any): void {
  //   this.propagateTouched = fn;
  // }

  // /* CVA */
  // setDisabledState(disabled: boolean): void {
  //   this.disabled = disabled;
  // }
}
